import { useNavigate } from 'react-router-dom';
import DetailScreen from '../components/DetailScreen';
import useTruflowData from '../hooks/useTruflowData';
import { ExpensesCard, DeductionSavingsCard, Spinner } from './Dashboard';

// Expenses tab — the running total, the recurring/one-time lists, and the
// estimated tax-savings card. The set-aside pools that used to sit above this
// moved to the Taxes screen, next to the reserve they fund.
export default function ExpensesScreen() {
  const navigate = useNavigate();
  const { loading, curveData, expensesData, deductionInsight } = useTruflowData();

  return (
    <DetailScreen title="Expenses">
      {loading ? (
        <Spinner />
      ) : (
        <>
          <ExpensesCard
            expensesData={expensesData}
            curveData={curveData}
            navigate={navigate}
            deductionInsight={deductionInsight}
          />
          <DeductionSavingsCard deductionInsight={deductionInsight} />
        </>
      )}
    </DetailScreen>
  );
}
